export default "__VITE_ASSET__D$PH8hhr__"